<template>
  <div
    v-if="notice"
    @close="closeNotice"
    class="bg-black/70 fixed inset-0 h-full w-full z-50 flex justify-center items-center p-4"
  >
    <div
      class="bg-white p-4 w-full max-w-xl relative max-h-[70%] overflow-auto rounded-lg"
    >
      <div id="notice" class="relative" style="z-index: 99">
        <div
          style="z-index: 99"
          class="relative w-full overflow-auto"
          v-if="
            props.operation.custom.notice &&
            props.operation.custom.notice != '<div><br></div>'
          "
        >
          <div v-html="props.operation.custom.notice" />
          <div class="m-auto py-6 w-full overflow-auto text-center">
            <button
              @click="handleClick()"
              class="m-auto cursor-pointer"
              id="participer"
            >
              Fermer
            </button>
          </div>
        </div>
        <div v-else class="relative w-full h-full overflow-visible">
          <h1 class="text-center py-12 font-bold w-full text-2xl">
            NOTICE D’INFORMATION RGPD
          </h1>
          <p>
            Les informations recueillies sur ce formulaire sont enregistrées
            dans un fichier informatisé par la
            <strong
              >SAS PROMODEV sise 276 Avenue du Douard, 13400 Aubagne
              Cedex</strong
            >, responsable de traitement pour le traitement de votre
            participation à l’opération
            <strong><span v-html="operation.name" /></strong>. <br />La base
            légale du traitement est l'exécution du contrat. <br /><br />
            Les données collectées seront communiquées aux seuls destinataires
            suivants : Organisateur de l’opération et le prestataire bancaire
            dans le cadre d’opérations financières. <br /><br />
            Les données sont conservées dans notre base courante pendant 12 mois
            après la fin du délai de réclamation de l’opération.<br /><br />
            Vos données relatives aux transactions bancaires (Nom prénom IBAN)
            seront sauvegardées pour des raisons légales sur une base archivée
            pendant 10 ans.<br />Vous pouvez accéder aux données vous
            concernant, les rectifier, demander leur effacement ou exercer votre
            droit à la limitation du traitement de vos données. <br /><br />
            Consultez le site
            <a href="https://www.cnil.fr/fr" target="_blank">cnil.fr</a> pour
            plus d’informations sur vos droits. <br /><br />
            Pour exercer ces droits ou pour toute question sur le traitement de
            vos données dans ce dispositif, vous pouvez contacter notre délégué
            à la protection des données :
            <a href="mailto:dpo@promo.dev"><strong>dpo@promo.dev</strong></a>
            <br /><br />
            Si vous estimez, après nous avoir contacté, que vos droits «
            Informatique et Libertés » ne sont pas respectés, vous pouvez
            adresser une réclamation à la
            <a href="https://www.cnil.fr/fr" target="_blank">CNIL</a>.
          </p>
          <div class="m-auto py-6 w-full text-center">
            <button
              @click="handleClick()"
              class="m-auto cursor-pointer"
              id="participer"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, defineProps, onMounted } from "vue";
const props = defineProps({
  operation: Object,
});

const notice = ref(false);
const closeNotice = () => {
  notice.value = false;
};

const handleClick = () => {
  notice.value = false;
};

onMounted(() => {
  setTimeout(() => {
    if (document.querySelector("#noticelink")) {
      document
        .querySelector("#noticelink")
        .addEventListener("click", (event) => {
          event.preventDefault();
          notice.value = true;
        });
    }
  }, 1000);
});
</script>
